// extracted by mini-css-extract-plugin
export default {"productDescription":"oaa-z","featuredDescription":"paa-z","description":"qaa-z","more":"raa-z","descriptionSku":"saa-z"};